module.exports = __webpack_public_path__ + "static/media/contra-cheque.8b7c6641.png";